import { Link, Stack, styled, Typography } from "@mui/material";

import { useCurrentExtranet } from "@/features/admin/hooks/queries";
import { RichText } from "@/features/shared/widgets";

const UnauthenticatedPage = () => {
  const { data, isError } = useCurrentExtranet();

  // The extranet content could not be loaded (e.g. the backend is unreachable).
  // Show an explicit unavailable message instead of the welcome fallback, which
  // would otherwise misrepresent a broken system as a normal, usable one.
  if (isError)
    return (
      <Stack p={2} alignItems="center">
        <Stack spacing={2} sx={{ maxWidth: "552px", marginTop: "50px" }}>
          <StyledTypography>De website is momenteel niet beschikbaar</StyledTypography>
          <StyledBodyTypography variant="body1">
            Er kan op dit moment geen verbinding met het systeem worden gemaakt, waardoor de
            website niet bruikbaar is. Probeer het later opnieuw. Blijft het probleem zich
            voordoen, neem dan contact op met de administrator.
          </StyledBodyTypography>
        </Stack>
      </Stack>
    );

  // fallback in case no content is defined or found
  if (!data?.general_info_content)
    return (
      <Stack p={2} alignItems="center">
        <Stack spacing={2} sx={{ maxWidth: "552px", marginTop: "50px" }}>
          <StyledTypography>Informatie over deze site</StyledTypography>
          <StyledBodyTypography variant="body1">
            Op basis van de Wet op het KNMI is de toegang tot mijn.knmi.nl (voorheen het
            extranet Overheid en Samenleving) beperkt. Indien u een account aanvraagt,
            verklaart u daarmee de beschikbare informatie alleen te zullen gebruiken in het
            kader van werkzaamheden die afgestemd zijn met de organisatie waar u werkt, dan
            wel volgt uit nader bepaalde wettelijke voorschriften. Het kan daarbij gaan om
            dagelijkse werkzaamheden, preparatie of afhandeling van een calamiteit en
            oefeningen/trainingsessies. Het KNMI behoudt zich het recht voor het rechtmatig
            gebruik van het extranet te toetsen.
          </StyledBodyTypography>
          <br />
          <StyledTypography>Geen account?</StyledTypography>
          <StyledBodyTypography variant="body1">
            Voor het aanvragen van een account op deze nieuwe website kan contact opgenomen
            worden met:{" "}
            <Link variant="body1" href="mailto:overheid@knmi.nl">
              overheid@knmi.nl
            </Link>
          </StyledBodyTypography>
        </Stack>
      </Stack>
    );

  return (
    <div
      style={{
        maxWidth: "552px",
        marginTop: "50px",
        marginInline: "auto",
        paddingInline: "var(--spacing-2x)",
      }}
    >
      {data.general_info_content && (
        <RichText
          configuration={{
            type: "rich_text",
            inputs: {
              location: false,
              time_range: false,
            },
            content: data.general_info_content,
          }}
        />
      )}
    </div>
  );
};

const StyledTypography = styled("h4")(`
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0;
`);

const StyledBodyTypography = styled(Typography)(`
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0.5px;
  margin-top: 0px!important;

  a {
    color: var(--blue);
    [data-theme="dark"] & {
      color: var(--blue-background);
    }
  }
`);

export default UnauthenticatedPage;
